import React, { Component } from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Redirect } from "react-router";

import "../../static/style/dashboard.css";
import Button from "../../components/Button";
import moment from "moment/moment";
import { withRouter } from "react-router-dom";
import { fetchDebts } from "../../actions";

class PlanInfo extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      redirect: false
    };
    this.upDateInstallments = this.upDateInstallments.bind(this)
  }
  upDateInstallments() {
    let redirect = false;
    if (!this.props.debts) {
      redirect = true;
    }

    if (!redirect) {
      const iid = this.props.match.params.id;
      let installment = null;

      for (var inst of this.props.debts.installments) {
        if (Number(inst.id) === Number(iid)) {
          installment = inst;
          break;
        }
      }

      if (installment) {
        this.setState({
          installment: installment
        });
      } else {
        redirect = true;
      }
    }

    this.setState({
      redirect: redirect
    });
  }
  componentDidMount() {
    if (Object.keys(this.props.debts).length && "installments" in this.props.debts) {
      this.upDateInstallments()
    } else {
      this.props.fetchDebts();
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.debts !== prevProps.debts) {
      this.upDateInstallments();
    }
  }

  getRow(row, index) {
    let paid = "";
    if (row.maksupaiva != null) {
      paid = "paid";
    }
    return (
      <div key={row.id} className={"row " + paid}>
        <div className="col-4">
          <p className="ass-card-guide">
            {index + 1} .{" "}
            <FormattedMessage
              id="app.dashcard.installment_no"
              defaultMessage="Erä"
            />
          </p>
        </div>
        <div className="col-4 text-center">
          <p className="ass-card-guide">
            {moment(row.erapaiva, "YYYY-MM-DD").format("D.M.YYYY")}
          </p>
        </div>
        <div className="col-4 text-right">
          <p className="ass-card-guide">{row.summa} €</p>
        </div>
      </div>
    );
  }

  render() {
    if (this.state.redirect === true) {
      return <Redirect to="/" />;
    }
    const installment = this.state.installment;

    if (installment) {
      return (
        <div className="row">
          <div className={"col-sm-12"}>
            <h1 className="header1">
              <FormattedMessage
                id="app.installment_plan.info"
                defaultMessage="Sopimuksen tiedot"
              />
            </h1>
            <ul className="list-unstyled">
              <li className="ass-car-list-element">
                <div className={"card"}>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-8">
                        <h3 className="card-title">
                          {installment.paamies.nimi}
                        </h3>
                        <h6 className="card-subtitle mb-2 ass-card-guide-s">
                          <FormattedMessage
                            id="app.dashcard.case_no"
                            defaultMessage="Asianumero"
                          />: {installment.id}
                        </h6>
                      </div>
                      <div className="col-md-4 text-right" />
                    </div>
                    <hr />
                    <div className="row">
                      <div className={"col-md-6"}>
                        <div className="row">
                          <div className="col-md-12">
                            <p className="ass-card-guide">
                              <FormattedMessage
                                id="app.dashcard.capital"
                                defaultMessage="Avoin pääoma"
                              />
                            </p>
                            <p className="ass-card-price">
                              {installment.maksusopimus.avoinna} €
                            </p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <p className="ass-card-guide">
                              <FormattedMessage
                                id="app.plan.part_count"
                                defaultMessage="Erien määrä"
                              />
                            </p>
                            <p className="ass-card-price">
                              {
                                Object.keys(
                                  installment.maksusopimus
                                    .maksusopimusera_erittely
                                ).length
                              }
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-12">
                            <p className="ass-card-guide">
                              <FormattedMessage
                                id="app.plan.total"
                                defaultMessage="Maksettava yhteensä"
                              />
                            </p>
                            <p className="ass-card-price">
                              {installment.maksusopimus.summa} €
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className={"col-md-6"}>
                        <p className="ass-card-price">
                          <FormattedMessage
                            id="app.plan.plan"
                            defaultMessage="Maksusuunnitelma"
                          />
                        </p>
                        <div className="row">
                          <div className="col-4">
                            <p className="ass-card-price">
                              <FormattedMessage
                                id="app.dashcard.installment_no"
                                defaultMessage="Erä"
                              />
                            </p>
                          </div>
                          <div className="col-4 text-center">
                            <p className="ass-card-price">
                              <FormattedMessage
                                id="app.dashcard.due"
                                defaultMessage="Eräpäivä"
                              />
                            </p>
                          </div>
                          <div className="col-4 text-right">
                            <p className="ass-card-price">
                              <FormattedMessage
                                id="app.plan.sum"
                                defaultMessage="Summa"
                              />
                            </p>
                          </div>
                        </div>
                        {installment.maksusopimus.maksusopimusera_erittely
                          ? installment.maksusopimus.maksusopimusera_erittely.map(
                            (row, index) => this.getRow(row, index)
                          )
                          : null}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <hr />
                        <p className="ass-card-price text-right">
                          <FormattedMessage
                            id="app.dashcard.total"
                            defaultMessage="Yhteensä"
                          />{" "}
                          {installment.maksusopimus.summa} €
                        </p>
                        <p className={"small text-right"}>
                          <FormattedMessage
                            id="app.dashcard.includes_costs"
                            defaultMessage="Sisältää kulut ja korot"
                          />
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <hr />
                        <Button
                          btnText={
                            <FormattedMessage
                              id="button.lbl.back"
                              defaultMessage="TAKAISIN"
                            />
                          }
                          btnStyle="primary"
                          btnPath="/dashboard"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      );
    } else {
      return <h1 className="header1">
        <FormattedMessage id="app.loading" defaultMessage="Ladataan..." />
      </h1>;
    }
  }
}

const mapStateToProps = function (store) {
  return {
    debts: store.debts
  };
};

const mapDispatchToProps = dispatch => ({
  fetchDebts: pin => dispatch(fetchDebts(pin)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PlanInfo));



// WEBPACK FOOTER //
// ./src/containers/PaymentPlan/PlanInfo.js